if (!customElements.get("page-detail-t4")) {
  customElements.define(
    "page-detail-t4",
    class PageDetailT4 extends HTMLElement {
      constructor() {
        super();
        this.$controller = new ScrollMagic.Controller();
      }

      getPageAffixedHeight() {
        // const areas = document.querySelectorAll(".shopify-section-group-header-group");
        const areas = document.querySelectorAll(".shopify-section--announcement-bar");
        let height = 0;
        areas.forEach((area) => {
          height += area.getBoundingClientRect().height;
        });
        return height;
      }

      createParallaxElement(triggerElement, triggerHook, durationTimes = 1) {
        // 创建一个 Scene，设置 pin 效果
        const scene = new ScrollMagic.Scene({
          triggerElement, // 从这个元素开始触发
          triggerHook, // 触发时在视口顶部（0 表示 top，0.5 是中间）
          duration: Math.max(1080, window.innerHeight) * durationTimes,
        }).addTo(this.$controller);
        return scene;
      }

      initSameParallax() {
        const triggerElements = document.querySelectorAll(".section3, .section7, .section9, .section12, .section17");
        triggerElements.forEach((triggerElement) => {
          this.createParallaxElement(triggerElement, 1).on("progress", (event) => {
            const progress = event.progress; // 0 ~ 1
            const triggerHalfHeight = triggerElement.getBoundingClientRect().height / 2.2;
            const translateY = Math.min(progress - 0.9, 0) * triggerHalfHeight;
            triggerElement.querySelector(".pdm4-parallax-info").style.transform = `translateY(${translateY}px)`;
          });
        });
      }

      initContent4Parallax() {
        const triggerElement = this.querySelector(".section4");
        this.createParallaxElement(triggerElement, 0, 1.5)
          .setPin(triggerElement.querySelector(".content-over-media"))
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            triggerElement.querySelector(".info1").style.opacity = Math.max(1 - event.progress * 2.5, 0);
            triggerElement.querySelector(".info1 .text").style.transform = `translateY(${-300 * Math.min(event.progress * 2.5, 1)}px)`;
            triggerElement.querySelector(".info2").style.opacity = Math.min(event.progress * 1.5, 1);
            triggerElement.querySelector(".info2 .text").style.transform = `translateY(${600 * Math.max(1 - event.progress * 1.5, 0)}px)`;
          });
      }

      iniContent4Swiper() {
        const wrapper = this.querySelector(".section4");
        new Swiper(wrapper.querySelector(".swiper"), {
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
          },
        });
      }

      iniContent5SwiperMobile() {
        const wrapper = this.querySelector(".section5");
        new Swiper(wrapper.querySelector(".swiper"), {
          slidesPerView: 2.3,
          slidesPerColumn: 2,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          slidesPerColumnFill: "row",
          autoplay: {
            delay: 3000,
          },
        });
      }

      initContent7_2Parallax() {
        const wrapper = this.querySelector(".section7-2");
        this.createParallaxElement(wrapper, 0, 1.5)
          .setPin(wrapper)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const _progress = event.progress - 0.5;
            const content = wrapper.querySelector(".pdm4-s7-2-container");
            const coleImage = wrapper.querySelector(".cole-image");
            const coleName = content.querySelector(".cole-name");
            wrapper.style.backgroundImage = `radial-gradient(ellipse 100% 100% at 50% ${Math.max(200 - 64 * event.progress * 3, 136)}%,#ff9300,#000)`;
            coleName.style.backgroundImage = `linear-gradient(150deg, #ff9300 ${Math.min(100 * event.progress * 2, 100)}%, #F83600 ${Math.min(
              100 * event.progress * 3,
              100
            )}%,#ffffff ${Math.min(100 * event.progress * 4, 100)}%)`;
            // if (event.progress > 0.5) {
            coleImage.style.opacity = Math.min(_progress * 3, 1);
            content.style.opacity = Math.max(1 - _progress * 3, 0);
            // }
          });
      }

      initContent7_2ParallaxMobile() {
        const wrapper = this.querySelector(".section7-2");
        this.createParallaxElement(wrapper, 0, 1.5)
          .setPin(wrapper)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const _progress = event.progress - 0.5;
            const content = wrapper.querySelector(".pdm4-s7-2-container");
            const coleImage = wrapper.querySelector(".cole-image");
            const coleName = content.querySelector(".cole-name");
            coleName.style.backgroundImage = `linear-gradient(150deg, #ff9300 ${Math.min(100 * event.progress * 2, 100)}%, #F83600 ${Math.min(
              100 * event.progress * 3,
              100
            )}%,#ffffff ${Math.min(100 * event.progress * 4, 100)}%)`;
            // if (event.progress > 0.5) {
            content.style.opacity = Math.max(1 - _progress * 4, 0);
            content.style.transform = `translateY(${Math.max(Math.min(_progress * 4, 1), 0) * -300}px)`;
            coleImage.style.opacity = Math.min(_progress * 3, 1);
            coleImage.style.transform = `translateY(${Math.max(1 - _progress * 3, 0) * 300}px)`;
            // }
          });
      }

      initContent8Swiper() {
        const wrapper = this.querySelector(".section8");
        const swiper = new Swiper(wrapper.querySelector(".swiper"), {
          direction: "vertical",
          // parallax: true,
          on: {
            slideChange: () => {
              wrapper.querySelector(".custom-pagination").dataset.activeIndex = swiper.activeIndex;
              wrapper.querySelectorAll(".custom-pagination p").forEach((item, index) => {
                item.classList.toggle("active", index === swiper.activeIndex);
              });
            },
          },
        });
        wrapper.querySelectorAll(".custom-pagination p").forEach((item, index) => {
          item.addEventListener("click", () => {
            swiper.slideTo(index);
          });
        });
      }

      initContent8SwiperMobile() {
        const wrapper = this.querySelector(".section8");
        new Swiper(wrapper.querySelector(".swiper"), {
          spaceBetween: 16,
          // parallax: true,
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
          },
        });
      }

      initContent10Swiper() {
        const wrapper = this.querySelector(".section10");
        const swiper_1 = new Swiper(wrapper.querySelector(".swiper-1"), { effect: "fade" });
        wrapper.querySelector(".swiper-2").style.height = wrapper.querySelector(".swiper-2 .swiper-slide").getBoundingClientRect().height + "px";
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          direction: "vertical",
          // parallax: true,
          spaceBetween: 32,
          on: {
            slideChange: () => {
              wrapper.querySelector(".custom-pagination").dataset.activeIndex = swiper_2.activeIndex;
              wrapper.querySelectorAll(".custom-pagination p").forEach((item, index) => {
                item.classList.toggle("active", index === swiper_2.activeIndex);
              });
            },
          },
        });
        wrapper.querySelectorAll(".custom-pagination p").forEach((item, index) => {
          item.addEventListener("click", () => {
            swiper_2.slideTo(index);
          });
        });
        swiper_2.controller.control = swiper_1;
      }

      initContent10SwiperMobile() {
        const wrapper = this.querySelector(".section10");
        const swiper_1 = new Swiper(wrapper.querySelector(".swiper-1"), { spaceBetween: 16 });
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          // parallax: true,
          spaceBetween: 16,
          on: {
            slideChange: () => {
              wrapper.querySelector(".custom-pagination").dataset.activeIndex = swiper_2.activeIndex;
              wrapper.querySelectorAll(".custom-pagination p").forEach((item, index) => {
                item.classList.toggle("active", index === swiper_2.activeIndex);
              });
            },
          },
        });
        wrapper.querySelectorAll(".custom-pagination p").forEach((item, index) => {
          item.addEventListener("click", () => {
            swiper_2.slideTo(index);
          });
        });
        swiper_2.controller.control = swiper_1;
        swiper_1.controller.control = swiper_2;
      }

      initContent14Parallax() {
        const triggerElement = this.querySelector(".section14");
        this.createParallaxElement(triggerElement, 0, 1)
          // .setPin(triggerElement)
          // .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const _y = triggerElement.getBoundingClientRect().height * event.progress;
            triggerElement.querySelector(".s14-info").style.transform = `translateY(${_y}px)`;
            triggerElement.querySelector(".s14-info").style.opacity = 1 - event.progress;
          });
      }

      initContent18Swiper() {
        const wrapper = this.querySelector(".section18-2");
        const collapseItems = wrapper.querySelectorAll(".collapse-item");
        const firstItem = collapseItems[0];
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          effect: "fade",
          on: {
            slideChange: () => {
              collapseItems.forEach((prev) => {
                prev.classList.remove("active");
                prev.querySelector(".ci-content").style.height = "0px";
              });
              const item = collapseItems[swiper_2.activeIndex];
              const contentHeight = item.querySelector(".ci-content p").getBoundingClientRect().height;
              item.classList.toggle("active");
              item.querySelector(".ci-content").style.height = `${contentHeight}px`;
            },
          },
        });
        firstItem.classList.add("active");
        firstItem.querySelector(".ci-content").style.height = firstItem.querySelector(".ci-content p").getBoundingClientRect().height + "px";
        collapseItems.forEach((item, index) => {
          item.querySelector(".ci-header").addEventListener("click", () => {
            collapseItems.forEach((prev) => {
              prev.classList.remove("active");
              prev.querySelector(".ci-content").style.height = "0px";
            });
            const contentHeight = item.querySelector(".ci-content p").getBoundingClientRect().height;
            item.classList.toggle("active");
            item.querySelector(".ci-content").style.height = `${contentHeight}px`;
            swiper_2.slideTo(index);
          });
        });
        // 初始化内容18的视差滚动
        this.createParallaxElement(wrapper, 0, 1)
          .setPin(wrapper)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const sectionBg = wrapper.querySelector(".section-bg");
            const sectionGroup = wrapper.querySelector(".section-group");
            const sectionContent = wrapper.querySelector(".pdm4-s18-2-container");
            const swiper2 = wrapper.querySelector(".swiper-2");
            sectionBg.style.transform = `translateX(${Math.min(event.progress * 2, 1) * -28.5}vw)`;
            sectionContent.style.transform = `translateX(${Math.max(1 - event.progress * 2, 0) * 23}vw)`;
            sectionGroup.style.transform = `translateX(${Math.max(1 - event.progress * 2, 0) * 28.5}vw)`;
            if (event.progress > 0.5) {
              swiper2.style.opacity = 1;
            } else {
              swiper2.style.opacity = 0;
              swiper_2.slideTo(0);
            }
          });
      }

      initContent18SwiperMobile() {
        const wrapper = this.querySelector(".section18-2");

        const swiper_1 = new Swiper(wrapper.querySelector(".swiper-1"), {
          spaceBetween: 16,
          slidesPerView: 1.2,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        });
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          spaceBetween: 16,
          slidesPerView: 1.2,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
          },
        });
        swiper_1.controller.control = swiper_2;
        swiper_2.controller.control = swiper_1;
      }

      initContent19DialPlate() {
        const wrapper = this.querySelector(".section19");
        const dialPlate = wrapper.querySelector(".dial-plate");
        const dialPlatePlayer = new ResponsiveSpritePlayer(dialPlate, {
          cols: 11,
          rows: 11,
          fps: 30,
          offsetX: 0,
          loop: true,
        });
        dialPlatePlayer.start();
      }
      initContent19DialPlateMobile() {
        const wrapper = this.querySelector(".section19");
        const dialPlate = wrapper.querySelector(".dial-plate");
        const dialPlatePlayer = new ResponsiveSpritePlayer(dialPlate, {
          cols: 11,
          rows: 11,
          fps: 30,
          offsetX: 0,
          loop: true,
        });
        dialPlatePlayer.start();
      }

      initContent20Parallax() {
        const wrapper = this.querySelector(".section20");
        const childs = Array.from(wrapper.querySelector(".pdm4-s20-container").childNodes).filter((item) => item.nodeType === 1);
        const watchElement = wrapper.querySelector(".s20-watch");
        this.createParallaxElement(wrapper, 1, 1).on("progress", (event) => {
          childs.forEach((item, index) => {
            if (item.nodeType === 1) {
              const _y = 300 * (index + 1) * Math.max(1 - event.progress * 1.5, 0);
              item.style.transform = `translateY(${_y}px)`;
              item.style.opacity = Math.min(event.progress * 1.5, 1);
            }
          });
          watchElement.style.transform = `translateY(${1000 * Math.max(1 - event.progress * 1.5, 0)}px)`;
          watchElement.style.opacity = Math.min(event.progress * 1.5, 1);
        });
      }

      initContent21Animation() {
        const wrapper = this.querySelector(".section21");
        const content_1 = wrapper.querySelector(".content-1");
        const content_2 = wrapper.querySelector(".content-2");
        const content_3 = wrapper.querySelector(".content-3");
        const content_4 = wrapper.querySelector(".content-4");
        const svgFramePlayer = new SvgFramePlayer(wrapper.querySelector(".svg-frame-player"), {
          fps: 16,
          loop: true,
        });
        this.createParallaxElement(wrapper, 0, 3)
          .setPin(wrapper)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const progress_2 = Math.max(event.progress - 0.2, 0);
            const progress_3 = Math.max(event.progress - 0.6, 0);
            svgFramePlayer.goTo(Math.round(event.progress * 107));
            content_1.style.transform = `translateY(-${300 * event.progress * 3}px)`;
            content_1.style.opacity = Math.max(1 - event.progress * 3, 0);
            content_2.style.transform = `translateY(${300 * Math.max(1 - progress_2 * 4, 0)}px)`;
            content_2.style.opacity = Math.min(progress_2 * 4, 1);
            if (progress_2 > 0 && progress_3 == 0) {
              content_3.style.transform = `translateY(${300 * Math.max(1 - progress_2 * 4, 0)}px)`;
              content_3.style.opacity = Math.min(progress_2 * 4, 1);
            }
            if (progress_3 > 0) {
              content_3.style.transform = `translateY(-${600 * Math.min(progress_3 * 6, 1)}px)`;
              content_3.style.opacity = Math.min(1 - progress_3 * 6, 1);
              content_4.style.transform = `translateY(${300 * Math.max(1 - progress_3 * 4, 0)}px)`;
              content_4.style.opacity = Math.min(progress_3 * 4, 1);
            }
          });
      }

      initContent22Swiper() {
        const wrapper = this.querySelector(".section22");
        const collapseItems = wrapper.querySelectorAll(".collapse-item");
        const firstItem = collapseItems[0];
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          // effect: "fade",
          on: {
            slideChange: () => {
              collapseItems.forEach((prev) => {
                prev.classList.remove("active");
                prev.querySelector(".ci-content").style.height = "0px";
              });
              const item = collapseItems[swiper_2.activeIndex];
              const contentHeight = item.querySelector(".ci-content p").getBoundingClientRect().height;
              item.classList.toggle("active");
              item.querySelector(".ci-content").style.height = `${contentHeight}px`;
            },
          },
        });
        firstItem.classList.add("active");
        firstItem.querySelector(".ci-content").style.height = firstItem.querySelector(".ci-content p").getBoundingClientRect().height + "px";
        collapseItems.forEach((item, index) => {
          item.querySelector(".ci-header").addEventListener("click", () => {
            collapseItems.forEach((prev) => {
              prev.classList.remove("active");
              prev.querySelector(".ci-content").style.height = "0px";
            });
            const contentHeight = item.querySelector(".ci-content p").getBoundingClientRect().height;
            item.classList.toggle("active");
            item.querySelector(".ci-content").style.height = `${contentHeight}px`;
            swiper_2.slideTo(index);
          });
        });
      }

      initContent22SwiperMobile() {
        const wrapper = this.querySelector(".section22");

        const swiper_1 = new Swiper(wrapper.querySelector(".swiper-1"), {
          // spaceBetween: 16,
          // slidesOffsetBefore: 16,
          // slidesOffsetAfter: 16,
        });
        const swiper_2 = new Swiper(wrapper.querySelector(".swiper-2"), {
          // spaceBetween: 16,
          // slidesOffsetBefore: 16,
          // slidesOffsetAfter: 16,
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
          },
        });
        swiper_1.controller.control = swiper_2;
        swiper_2.controller.control = swiper_1;
      }

      initContent22Parallax() {
        const wrapper = this.querySelector(".section22");
        const content_1 = wrapper.querySelector(".content-app");
        const content_2 = wrapper.querySelector(".content-info");
        const content_3 = wrapper.querySelector(".content-phone");
        const content_4 = wrapper.querySelector(".content-phone .phone-frame>img");
        const content_5 = wrapper.querySelector(".content-phone .swiper-2");
        this.createParallaxElement(wrapper, 0, 2)
          .setPin(wrapper)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            content_1.style.transform = `translateY(${-600 * Math.min(event.progress * 2, 1)}px)`;
            content_1.style.opacity = Math.max(1 - event.progress * 2, 0);
            content_2.style.transform = `translateY(${600 * Math.max(1 - event.progress * 2, 0)}px)`;
            content_2.style.opacity = Math.min(event.progress * 2, 1);
            content_3.style.transform = `translateX(${100 * Math.min(event.progress * 2, 1)}px)`;
            content_4.style.opacity = Math.max(1 - event.progress * 2, 0);
            content_5.style.opacity = Math.min(event.progress * 2, 1);
          });
      }

      initAnchorEvents() {
        const spans = this.querySelectorAll("[data-apex-anchor-to]");
        spans.forEach((span) => {
          span.addEventListener("click", (e) => {
            const anchorTarget = span.dataset.apexAnchorTo;
            const anchor = this.querySelector(`[data-apex-anchor="${anchorTarget}"]`);
            anchor.scrollIntoView({ behavior: "smooth" });
          });
        });
      }

      initVideoFullScreenPlay() {
        const triggerElements = this.querySelectorAll(".play-video-full");
        triggerElements.forEach((triggerElement) => {
          triggerElement.addEventListener("click", () => {
            const videoUrl = triggerElement.getAttribute("data-url");
            const video = document.createElement("video");
            video.src = videoUrl;
            video.controls = true;
            video.muted = true;
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
            video.classList.add("full-video");
            const maskDom = document.createElement("div");
            maskDom.classList.add("full-video-mask", "animate__animated", "animate__fadeIn");
            document.body.appendChild(maskDom);
            document.body.appendChild(video);
            video.play();
            maskDom.addEventListener("click", () => {
              video.pause();
              document.body.removeChild(video);
              document.body.removeChild(maskDom);
            });
          });
        });
      }

      initContent23Swiper() {
        const wrapper = this.querySelector(".section23");
        const tabs = wrapper.querySelectorAll(".section-tabs .section-tab");
        const allPlateWraps = wrapper.querySelectorAll(".plate-items");
        const prevBtn = wrapper.querySelector(".tabs-left");
        const nextBtn = wrapper.querySelector(".tabs-right");
        const swiper = new Swiper(wrapper.querySelector(".swiper"), {
          slidesPerView: 1,
          threshold: 30,
        });
        // 切换tab
        const changeTab = (index, slide = true, intoView = true) => {
          const activeTab = wrapper.querySelector(".section-tabs .section-tab.active");
          const prevIndex = Number(activeTab.dataset.index);
          if (prevIndex === index && slide) {
            return;
          }
          activeTab.classList.remove("active");
          tabs[index].classList.add("active");
          let nextIndex = index;
          if (index > prevIndex) {
            nextIndex = index + 2 > tabs.length - 1 ? tabs.length - 1 : index + 2;
          } else if (index < prevIndex) {
            nextIndex = index - 2 < 0 ? 0 : index - 2;
          }
          if (intoView) {
            tabs[nextIndex].scrollIntoView({ behavior: "smooth", block: window.innerWidth > 768 ? "start" : "center" });
          }
          const activePlateWrap = wrapper.querySelector(`.plate-items[data-index="${index}"]`);
          const firstPlate = activePlateWrap.querySelector(".plate-item");
          changePlate(firstPlate, 0);
          if (index === 0) {
            prevBtn.classList.add("disabled");
          } else {
            prevBtn.classList.remove("disabled");
          }
          if (index === tabs.length - 1) {
            nextBtn.classList.add("disabled");
          } else {
            nextBtn.classList.remove("disabled");
          }
          if (slide) {
            swiper.slideTo(index);
          }
        };
        // 切换表盘
        const changePlate = (elem, index) => {
          const wrapElem = elem.closest(".plate-items");
          const wrapIndex = Number(wrapElem.dataset.index) + 1;
          const activePlate = wrapElem.querySelector(`.active`);
          const plateViewEl = wrapper.querySelector(".plate-box");
          if (activePlate) {
            activePlate.classList.remove("active");
          }
          elem.classList.add("active");
          const _width = plateViewEl.getBoundingClientRect().width;
          const _height = plateViewEl.getBoundingClientRect().height;
          plateViewEl.style.backgroundImage = `url(https://cdn.shopify.com/s/files/1/0505/8776/2846/files/page-xt4-s23-plate${wrapIndex}.png)`;
          plateViewEl.style.backgroundSize = `${_width * 3}px ${_height * 3}px`;
          const _x = index % 3;
          const _y = Math.floor(index / 3);
          plateViewEl.style.backgroundPosition = `-${_width * _x}px -${_height * _y}px`;
        };
        swiper.on("slideChange", () => {
          const activeIndex = swiper.activeIndex;
          changeTab(activeIndex, false);
        });
        tabs.forEach((tab, index) => {
          tab.addEventListener("click", () => {
            changeTab(index);
          });
        });
        prevBtn.addEventListener("click", () => {
          swiper.slidePrev();
        });
        nextBtn.addEventListener("click", () => {
          swiper.slideNext();
        });
        allPlateWraps.forEach((plateWrap) => {
          const allPlates = plateWrap.querySelectorAll(".plate-item");
          allPlates.forEach((plate, index) => {
            plate.addEventListener("click", (e) => {
              changePlate(plate, index);
            });
          });
        });
        changeTab(0, false, false);
      }

      iniContent24SwiperMobile() {
        const wrapper = this.querySelector(".section24");
        new Swiper(wrapper.querySelector(".swiper"), {
          spaceBetween: 16,
          slidesPerView: 1.2,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
          },
        });
      }

      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () => {
          if (window.innerWidth > 768) {
            this.initContent4Parallax();
            this.initContent7_2Parallax();
            // this.initContent8Swiper();
            this.initContent10Swiper();
            this.initSameParallax();
            // this.initContent14Parallax();
            this.initContent18Swiper();
            this.initContent19DialPlate();
            this.initContent20Parallax();
            this.initContent22Swiper();
            this.initContent22Parallax();
          } else {
            this.iniContent4Swiper();
            this.iniContent5SwiperMobile();
            this.initContent7_2ParallaxMobile();
            // this.initContent8SwiperMobile();
            this.initContent10SwiperMobile();
            this.initContent18SwiperMobile();
            this.initContent19DialPlateMobile();
            this.initContent22SwiperMobile();
            this.iniContent24SwiperMobile();
          }
          this.initContent21Animation();
          this.initAnchorEvents();
          this.initVideoFullScreenPlay();
          this.initContent23Swiper();
        });
      }
    }
  );
}
